export function every<T>(...conditions: T[]): boolean {
	return conditions.every((condition) => !!condition)
}
